module.exports = __webpack_public_path__ + "img/pro_01transfer_ok.77e1c25c.png";